import { createRouter, createWebHistory } from 'vue-router'

import { generateRoutes } from '@/extensions/langRouter'

const NotFound = () => import('@/views/NotFound.vue')

const routes = [
  {
    path: '/',
    paths: { en: '/' },
    name: 'home',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/certificat',
    paths: { en: '/certificate' },
    name: 'certificate',
    component: () => import('@/views/Certificate.vue'),
  },
  {
    path: '/formations/:courseSlug',
    paths: { en: '/courses/:courseSlug' },
    name: 'course',
    component: () => import('@/views/Course.vue'),
    props: true,
  },
  {
    path: '/confidentialite',
    paths: { en: '/privacy' },
    name: 'privacy',
    component: () => import('@/views/Privacy.vue'),
  },
  {
    path: '/modalites-sms',
    paths: { en: '/sms-terms' },
    name: 'sms-terms',
    component: () => import('@/views/SmsTerms.vue'),
  },
  {
    path: '/404',
    name: 'not-found',
    component: NotFound,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'catch-all',
    component: NotFound,
  },
]

const localizedRoutes = generateRoutes(routes, 'fr', ['en'])

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  linkActiveClass: '-active',
  linkExactActiveClass: '-exact-active',
  routes: localizedRoutes,
})

export default router
